module.exports = __webpack_public_path__ + "img/Copy of Peddrew Bowling.9ee73543.jpg";